export const initConsentManager = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      // Configurar el gestor de consentimiento primero
      window.cmp_host = 'a.delivery.consentmanager.net';
      window.cmp_cdn = 'cdn.consentmanager.net';
      window.cmp_codesrc = '16';
      window.cmp_id = '65c15843e23fc';

      // Cargar el script del gestor de consentimiento
      const script = document.createElement('script');
      script.src = 'https://cdn.consentmanager.net/delivery/autoblocking/65c15843e23fc.js';
      script.async = true;
      script.defer = true;
      script.dataset.cmp = 'true';

      script.onload = () => {
        // Esperar a que el objeto _cmp esté disponible
        const checkCMP = setInterval(() => {
          if (window._cmp) {
            clearInterval(checkCMP);
            resolve();
          }
        }, 100);

        // Timeout después de 5 segundos
        setTimeout(() => {
          clearInterval(checkCMP);
          resolve(); // Resolver de todos modos para no bloquear la aplicación
        }, 5000);
      };

      script.onerror = error => {
        reject(new Error('Failed to load consent manager script: ' + error));
      };

      document.head.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};
